const restoreAllCategory = async ({ token, id }) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/restore_categories_all?ids=${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default restoreAllCategory;
